import { ResponsiveMenuItem } from 'components/DropdownButtons/_utils/ResponsiveMenuItem'
import type { StackedChartSection } from 'components/StackedChart/types'
import { translate } from 'i18n/i18n'
import { detailsPanelStore } from 'stores/detailsPanelStore/detailsPanelStore'
import { selectedPropertyHasPermission } from '../../_utils/selectedPropertyHasPermission'
import { FruitGrowthSettingsModal } from './FruitGrowthSettingsModal'

type FruitGrowthSettingsLinksProps = {
  timezone: string
  defaultTargetSize: number | null
  defaultTargetDate: string | null
  defaultTargetSizeUnit: 'INCH' | 'MILLIMETER' | null
}

export const FruitGrowthTitleLink = ({
  timezone,
  defaultTargetSize,
  defaultTargetDate,
  defaultTargetSizeUnit,
}: FruitGrowthSettingsLinksProps) => {
  const titleLink: NonNullable<StackedChartSection['titleLink']> = []

  if (!selectedPropertyHasPermission({ permission: 'EDIT_FRUIT_DENDROMETER_SETTINGS' })) {
    return titleLink
  }

  titleLink.push(
    <>
      <ResponsiveMenuItem
        key="fruit-growth-menu-item"
        data-role="menu-item"
        onClick={() => {
          detailsPanelStore.setState((prev) => {
            return {
              ...prev,
              fruitGrowthSettingsOpened: true,
            }
          })
        }}
      >
        {translate.phrases.banyanApp('Edit Fruit Growth Settings')}
      </ResponsiveMenuItem>
      <FruitGrowthSettingsModal
        key="fruit-growth-modal"
        data-role="modal"
        timezone={timezone}
        defaultTargetSize={defaultTargetSize}
        defaultTargetDate={defaultTargetDate}
        defaultTargetSizeUnit={defaultTargetSizeUnit}
      />
    </>,
  )

  return titleLink
}
